/**
 * Status einer Veranstaltungsbuchung
 */
export enum EventBookingStatus {
  /**
    * Anfrage ist noch nicht vollständig.
    */
  incomplete = "incomplete", 
  
  /**
    * Buchungsanfrage vom Kunden erhalten.
    */
   requested = "requested",

   /**
    * Kursbuchung ist auf Warteliste.
    */
   waitingList = "waitingList",

   /**
    * Buchung ist vollständig, Anzahlung kann vom Konto eingesammelt werden.
    */
   bookedReadyForDepositPayment = "bookedReadyForDepositPayment",

   /**
    * Buchung ist vollständig, Anzahlungsrechnung wurde exportiert.
    */
   bookedDepositPaymentExported = "bookedDepositPaymentExported",

   /**
    * Veranstaltung durchgeführt, Rechnung kann gestellt werden.
    */
   readyForPayment = "readyForPayment",

   /**
    * Veranstaltung wurde exportiert. Jetzt ist nichts mehr zu tun.
    */
   paymentExported = "paymentExported",

   /**
     * Buchung wurde als bezahlt markiert.
     */
   paymentReceived = "paymentReceived",

   /**
    * Buchung wurde storniert. Rechnung fuer Stornierungsgebuehr kann gestellt werden.
    */
   canceled = "canceled",

   /**
    * Buchung wurde storniert und Stornierungsgebuehr wurde exportiert.
    */
   cancellationFeeExported = "cancellationFeeExported",

   /**
     * Buchung wurde storniert und die Gebühr als bezahlt markiert.
     */
   cancellationFeeReceived = "cancellationFeeReceived",
}

export const EventBookingStatusNames = {
  incomplete: "Unvollständig", 
  requested: "Angefragt",
   waitingList: "Auf Warteliste",
   bookedReadyForDepositPayment: "Bereit für Anzahlung",
   bookedDepositPaymentExported: "Gebucht, Anzahlung exportiert",
   readyForPayment: "Bereit für Bezahlung",
   paymentExported: "Rechnung wurde exportiert",
   paymentReceived: "Als bezahlt markiert",
   canceled: "Storniert, Gebühr-Export ausstehend",
   cancellationFeeExported: "Storniert, Gebühr wurde exportiert",
   cancellationFeeReceived: "Storniert, als bezahlt markiert",
};